//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/icons/jha-icon-filter";
import "@banno/jha-wc/src/icons/jha-icon-refresh";
import "@banno/jha-wc/src/collapsible-content/jha-collapsible-section/jha-collapsible-section";
import "@banno/jha-wc/src/forms/jha-form-date-input/jha-form-date-input";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/icons/jha-icon-download";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "@banno/jha-wc/src/icons/jha-icon-circle-close-filled";
import "@banno/jha-wc/src/icons/jha-icon-information";
import { GlobalConstants, GlobalVariables } from "../../utils/constants";
import { Apis } from "../../utils/api-constants";
import { getRequest, postFileRequest, postRequest, postRequestAnyType } from "../../utils/jha-fetch";
import { getRoleData } from "../../utils/getRoleData";
import Cookies from "js-cookie";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { AppRouters } from "../../utils/app-router";
import "../../Components/Loader";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import "@banno/jha-wc/src/jha-badge/jha-badge";
import { stringComparison, getStatusToLowerCase, AUDIT_STATUS_BADGE_MAP, renderStatusBadge, decryptValue, getCurrentTimezone, getCurrentOffset } from "../../utils/app-utils";
import {
  buildCsvExportFilename,
  DURATION_COLUMN_LABEL,
  dateTimeColumnLabel,
  formatAuditTransDuration,
  formatEpochSecondsForDisplay,
  mapAuditGridRowForSort,
  normalizeEpochSeconds,
  orderLoadedRowsByEpoch,
  getAuditTransDurationEmptyLabel,
} from "../../utils/datetime-display";
import {
  filterSelectBackspaceClearKeydown,
  pickerOnlyDateFieldKeydown,
} from "../../utils/filter-field-keyboard";
import { StatusConstants } from "../../utils/apiStatusConstants";
import { dateFormatter } from "../../utils/dateFormatter";
import { getBusinessUnitName } from "../../utils/getBusinessUnitName";
import { REPORT_EXPORT_SCREEN_LABEL } from "../../constants/report-export-screen-label";
@customElement("audit-export")
export class ExportExcel extends routingMixin(LitElement) {
  /** ponytail: audit-export rejects end-of-local-day that falls on UTC "today"; keep max end 2 local days back */
  static readonly EXPORT_MAX_END_DAYS_AGO = 2;

  static get is() {
    return "audit-export";
  }
  constructor() {
    super();
  }
  static readonly styles = css`
    jha-icon-circle-checkmark-filled {
      fill: var(--jha-color-success);
    }
    jha-icon-circle-close-filled {
      fill: var(--jha-color-warning);
    }
    #formCon {
      display: flex;
      flex-direction: column;
    }
    #reportingDiv {
      display: flex;
      flex-direction: column;
      padding: 24px;
      gap: 15px;
      height:100%;
      width: 100%;
      box-sizing: border-box;
    }
    jha-form-row {
      align-items: baseline;
      justify-content: flex-end;
      flex: 1;
    }
    .filter-action-buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 12px;
      margin-top: 33px;
    }
    .filter-action-buttons jha-tooltip {
      display: inline-flex;
      flex: 0 0 auto;
    }
    .filter-action-buttons jha-button {
      width: auto;
      min-width: fit-content;
    }
    jha-table-header {
      width: 20vw;
    }
    jha-card {
      flex: 1;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }
    #filterBody {
      display: flex;
      flex-direction: column; 
    }
    #filterId {
      display: grid;
      justify-content: start;
    }
    #dateDiv {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      column-gap: 15px;
    }
    jha-form-select {
      width: 340px;
    }
    #noData {
      display: flex;
      justify-content: center;
    }
    #traceId {
      min-width: 250px;
      margin-left:15px;
    }
    .table-container {
      display: flex;
      height: 100%;
    }
  `;
  @property({ type: Object })
  auditData: AuditDashboardTableData = {
    messageStatus: "",
    results: [],
    paging: 0,
    eTags: "",
  };
  @property({ type: Object })
  auditFetchedData: AuditDashboardTableData = {
    messageStatus: "",
    results: [],
    paging: 0,
    eTags: "",
  };
  @property()
  minDate: Date
  @property()
  maxDate: Date
  @property()
  filterTraceId = "";
  @property()
  defaultDt = new Date();
  @property()
  startDate
  @property()
  itemsFormatted = [];
  @property()
  startTime = "00:00";
  @property()
  endDate
  @property()
  endTime = this.getCurrentTime();
  @property()
  loggedUserType = decryptValue(Cookies.get("userType"))
  @property()
  businessUnit = stringComparison(this.loggedUserType, "BusinessAdmin") ? Cookies.get("businessUnit")?.toLowerCase() : '';

  @property({ type: Array })
  columns = [
    {
      label: "TRACE ID",
      id: "traceId",
    },
    {
      label: dateTimeColumnLabel("STARTED"),
      id: "transStart",
      sortBy: true,
      dataType: "number",
      valueFormatter: () => "",
      valueRenderer: (val: unknown) => html`
        <span style="white-space: nowrap;"
          >${formatEpochSecondsForDisplay(normalizeEpochSeconds(val))}</span
        >
      `,
    },
    {
      label: dateTimeColumnLabel("COMPLETED"),
      id: "transEnd",
      sortBy: true,
      dataType: "number",
      valueFormatter: () => "",
      valueRenderer: (val: unknown) => html`
        <span style="white-space: nowrap;"
          >${formatEpochSecondsForDisplay(normalizeEpochSeconds(val))}</span
        >
      `,
    },
    {
      label: DURATION_COLUMN_LABEL,
      id: "transDuration",
      sortBy: true,
      dataType: 'number',
      valueRenderer: (val, row) => {
        const formatted = formatAuditTransDuration(val, row?.transTime);
        if (!formatted) {
          const inProgressLabel = getAuditTransDurationEmptyLabel(row?.status);
          if (inProgressLabel) {
            return html`<span>${inProgressLabel}</span>`;
          }
          return html`--`;
        }
        return html`<span style="white-space: nowrap;">${formatted.display}</span>`;
      },
    },
    {
      label: "STATUS",
      id: "status",
      sortBy: true,
      filterType: 'list',
      options: ['success', 'error', 'init'],
      filters: [
        {
          label: 'STATUS',
          id: 'status',
        },
      ],
      dataType: 'badge',
      badgeMap: [...AUDIT_STATUS_BADGE_MAP],
      valueRenderer: (val: string) => renderStatusBadge(val),
    },
    {
      label: "BUSINESS UNIT",
      id: "businessUnit",
      sortBy: true,
    },
    {
      label: "SOURCE PATH",
      id: "sourceFilePath",
      sortBy: true,
    },
    {
      label: "SOURCE SERVER",
      id: "sourceFileServer",
      sortBy: true,
    },
    {
      label: "DESTINATION SERVER",
      id: "destinationFileServer",
      sortBy: true,
    },
  ].slice();
  @property()
  sortColumnId = "";
  @property()
  sortDirection = "";
  @property()
  loading = false;
  @property()
  startDateTime = ""
  @property()
  endDateTime = ""

  @property({ type: Array })
  businessUnits = [];
  @property({ type: Object })
  advancedTableConfig = {
    apiControlled: true,
    apiTotal: 2000,
    sort: {
      columnId: 'transStart',
      descending: true,
    },
  };
  @property({ type: Boolean })
  loadingMore = false;
  @property()
  nextPageKey = "";
  @property()
  pageLimit = 100;
  @property()
  lastTraceId = "";
  @property({ type: Boolean })
  datesUpdated = false;
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  getDefaultExportEndDate() {
    const d = new Date();
    d.setDate(d.getDate() - ExportExcel.EXPORT_MAX_END_DAYS_AGO);
    return d;
  }

  getCurrentTime() {
    var now = new Date();
    var hours = now.getHours().toString().padStart(2, "0");
    var minutes = now.getMinutes().toString().padStart(2, "0");
    return hours + ":" + minutes;
  }



  logStartDateTime() {
    let startDateTime = "";
    if (this.startDate) {
      startDateTime += this.startDate;
      if (this.startTime) {
        startDateTime += " " + this.startTime;
      } else {
        startDateTime += " 00:00:00";
      }
    } else if (this.startTime) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      startDateTime = `${year}-${month}-${day} ${this.startTime}`;
    }
    startDateTime = startDateTime + " " + getCurrentOffset();
    return startDateTime;
  }

  logEndDateTime() {
    let endDateTime = "";
    if (this.endDate) {
      endDateTime += this.endDate;
      if (this.endTime) {
        endDateTime += " " + this.endTime;
      } else {
        endDateTime += " 23:59:59";
      }
    } else if (this.endTime) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      endDateTime = `${year}-${month}-${day} ${this.endTime}`;
    }
    endDateTime = endDateTime + " " + getCurrentOffset();
    return endDateTime;
  }

  /** Date-only export page: full local days for audit-export API (matches AuditDashboard contract). */
  buildExportDateTimeRange(startDate: string, endDate: string) {
    const savedStartDate = this.startDate;
    const savedEndDate = this.endDate;
    const savedStartTime = this.startTime;
    const savedEndTime = this.endTime;
    this.startDate = startDate;
    this.endDate = endDate;
    this.startTime = "";
    this.endTime = "";
    const range = {
      logStartDateTime: this.logStartDateTime(),
      logEndDateTime: this.logEndDateTime(),
    };
    this.startDate = savedStartDate;
    this.endDate = savedEndDate;
    this.startTime = savedStartTime;
    this.endTime = savedEndTime;
    return range;
  }

  onFiltersClickReset() {
    this.onSearchClear();
    const resetDt = this.getDefaultExportEndDate();
    this.startDate = this.formatDate(resetDt);
    this.startTime = "00:00";
    this.endDate = this.formatDate(resetDt);
    this.endTime = this.getCurrentTime();
    this.businessUnit = stringComparison(this.loggedUserType, "BusinessAdmin") ? this.businessUnit : "";
    this.sortColumnId = "";
    this.sortDirection = "";
  }

  isValidTime(str) {
    let regex = new RegExp(/^ *([01]?\d|2[0-3]):([0-5]\d) *$/);

    if (!str) {
      return true;
    }

    if (regex.test(str) == true) {
      return true;
    } else {
      return false;
    }
  }

  get listData() {
    const rows = (this.auditData.results ?? []).map((item) =>
      mapAuditGridRowForSort({ ...item }),
    );
    const sort = this.advancedTableConfig?.sort;
    return orderLoadedRowsByEpoch(rows, sort?.columnId, sort?.descending, [
      "transStart",
      "transEnd",
    ]);
  }


  getUTCDateTime(dateVal) {
    let oDate = new Date(dateVal);
    return `${oDate.getUTCFullYear()}-${oDate.getUTCMonth() + 1}-${oDate.getUTCDate()} ${oDate.getUTCHours()}:${oDate.getUTCMinutes()}`
  }

  @property()
  pageTitle = REPORT_EXPORT_SCREEN_LABEL;

  async connectedCallback() {
    super.connectedCallback();
    document.title = GlobalVariables.MAIN_TITLE?.concat(" >", this.pageTitle);

    const businessUnitsAllRes = await getRequest(Apis.GET_ALL_BUSINESSUNITVALUES);
    if (!businessUnitsAllRes) {
      this.businessUnits = [];
    } else {
      const businessUnitsRes = (businessUnitsAllRes?.businessUnitValues ?? []);
      this.businessUnits = businessUnitsRes.filter((bu) => bu.status === "active" || bu.name.toLowerCase() === this.businessUnit?.toLocaleLowerCase())
        .map((y) => {
          return { value: y.value, name: y.name };
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    this.defaultDt = this.getDefaultExportEndDate();
    this.startDate = this.formatDate(this.defaultDt);
    this.endDate = this.formatDate(this.defaultDt);
    var inputDate = new Date();
    this.minDate = dateFormatter(inputDate, { months: -GlobalConstants.CALENDAR_MIN_DATE_MONTHS });
    this.maxDate = dateFormatter(inputDate, { days: -ExportExcel.EXPORT_MAX_END_DAYS_AGO });
  }

  onKeyPress(e: Event) {
    if (e.type === 'keyup') {
      const k = e as KeyboardEvent
      if (k.key === 'Enter') {
        this.onFiltersClick();
      }
    }
  }
  onSearchClear() {
    this.filterTraceId = "";
  }
  onStartDateChange(e: { target: { value: string } }) {
    this.startDate = e.target.value;
  }
  onStartDateTimeChange(e: { target: { value: string } }) {
    this.startTime = e.target.value;
  }
  onEndDateChange(e: { target: { value: string } }) {
    this.endDate = e.target.value;
  }
  onEndDateTimeChange(e: { target: { value: string } }) {
    this.endTime = e.target.value;
  }
  onBusinessUnitChange(e: { target: { value: string } }) {
    this.businessUnit = e.target.value;
  }

  onExportBusinessUnitSelectKeydown(e: KeyboardEvent) {
    filterSelectBackspaceClearKeydown(e, {
      value: this.businessUnit,
      locked: stringComparison(this.loggedUserType, "BusinessAdmin"),
      onClear: () => this.onBusinessUnitChange({ target: { value: "" } }),
    });
  }
  async exportTocsv() {
    const resetDt = this.getDefaultExportEndDate();
    const startDate =
      this.startDate === "" ? this.formatDate(resetDt) : this.startDate;
    const endDate =
      this.endDate === "" ? this.formatDate(resetDt) : this.endDate;
    this.datesUpdated = false;
    if (endDate >= startDate) {
      this.loading = true;
      try {
        const { logStartDateTime, logEndDateTime } =
          this.buildExportDateTimeRange(startDate, endDate);
        const res = await postFileRequest(Apis.AUDIT_EXPORT, {
          businessUnit: this.businessUnit ?? "",
          logStartDateTime,
          logEndDateTime,
        });
        if (!res) {
          return;
        }
        if (res?.status === StatusConstants.NOT_FOUND_USER_CODE) {
          showToast({
            message: "No Data found",
            role: "danger",
            duration: GlobalVariables.TOAST_TIMEOUT,
          });
        } else if (res?.details?.length > 0) {
          const errMsg = getErrorMessage(res.details);
          showToast({
            message: errMsg,
            role: "danger",
            duration: GlobalVariables.TOAST_TIMEOUT,
          });
        } else if (res) {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(res);
          link.download = buildCsvExportFilename("Report");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
          showToast({
            message: "The report has been downloaded successfully",
            role: "success",
            duration: GlobalVariables.TOAST_TIMEOUT,
          });
        }
      } catch {
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
      } finally {
        this.loading = false;
      }
    } else {
      showToast({
        message: "End Date must be greater or equal to start date",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
    if (this.startDate === "" || this.endDate === "") {
      const fallbackDt = this.getDefaultExportEndDate();
      this.startDate = this.formatDate(fallbackDt);
      this.endDate = this.formatDate(fallbackDt);
      this.datesUpdated = true;
    }
  }

  render() {
    return html`
      <slot>
        ${this.loading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="reportingDiv">
          <div id="formCon">
            <h1>${REPORT_EXPORT_SCREEN_LABEL}</h1>
              <div slot="header"></div>
              <div slot="body" id="filterBody">
                <div id="filterId">
                <p>Note: The data available to export is till one day prior as per UTC timezone. </p>
                  <div id="dateDiv">
                    ${getCurrentTimezone().includes(GlobalConstants.TIMEZONE)
        ? html`
                          <jha-form-date-input
                            data-auto-id="startDateAsiaInput"
                            min=${this.minDate}
                            max=${this.maxDate}
                            warning="Invalid date"
                            @keydown=${pickerOnlyDateFieldKeydown}
                            id
                            type="date"
                            minlength="0"
                            maxlength="10"
                            role="textbox"
                            outline
                            label="Start Date"
                            .value=${this.startDate}
                            @change=${this.onStartDateChange}
                          ></jha-form-date-input>
                        `
        : html`
                        <jha-tooltip bottom text="Select start date.">
                          <jha-form-date-input
                            data-auto-id="startDateInput"
                            min=${this.minDate}
                            max=${this.maxDate}
                            @keydown=${pickerOnlyDateFieldKeydown}
                            warning="Invalid date"
                            id
                            type="date"
                            minlength="0"
                            maxlength="10"
                            role="textbox"
                            outline
                            label="Start Date"
                            .value=${this.startDate}
                            @change=${this.onStartDateChange}
                          ></jha-form-date-input>
                        </jha-tooltip>
                        `}
                    ${getCurrentTimezone().includes(GlobalConstants.TIMEZONE)
        ? html`
                          <jha-form-date-input
                            data-auto-id="endDateAsiaInput"
                          min=${this.minDate}
                          max=${this.maxDate}
                          @keydown=${pickerOnlyDateFieldKeydown}
                            warning="Invalid date"
                            outline
                            type="date"
                            minlength="0"
                            maxlength="10"
                            role="textbox"
                            label="End Date"
                            .value=${this.endDate}
                            @change=${this.onEndDateChange}
                          ></jha-form-date-input>
                        `
        : html`
                        <jha-tooltip bottom text="Select end date.">
                          <jha-form-date-input
                            data-auto-id="endDateInput"
                            min=${this.minDate}
                            max=${this.maxDate}
                            @keydown=${pickerOnlyDateFieldKeydown}
                            warning="Invalid date"
                            outline
                            type="date"
                            minlength="0"
                            maxlength="10"
                            role="textbox"
                            label="End Date"
                            .value=${this.endDate}
                            @change=${this.onEndDateChange}
                          ></jha-form-date-input>
                        </jha-tooltip>
                        `}
                    <jha-tooltip
                      bottom
                      text="Select Business Unit. When focused, press Backspace to clear the selection."
                    >
                        <jha-form-select
                          outline
                          label="Business Unit"
                          .options=${this.businessUnits}
                          lableKey="name"
                          valueKey="value"
                          data-id="businessUnit"
                          data-auto-id="businessUnitSelect"
                          emptyOptionLabel="Select Business Unit"
                          .value=${this.businessUnit}
                          @change=${this.onBusinessUnitChange}
                          @keydown=${this.onExportBusinessUnitSelectKeydown}
                          ?disabled=${stringComparison(this.loggedUserType, "BusinessAdmin")}
                      ></jha-form-select>
                    </jha-tooltip>
                  </div>
                  <div class="filter-action-buttons">
                    <jha-tooltip
                      top-right
                      text="Click to export report."
                    >
                      <jha-button
                        data-auto-id="exportCsvBtn"
                        type="button"
                        primary
                        large
                        sync
                        ?disabled=${this.loading}
                        @click=${() => void this.exportTocsv()}
                        ><jha-icon-download
                          slot="icon-left"
                        ></jha-icon-download
                        >Export</jha-button
                      >
                    </jha-tooltip>
                    <jha-tooltip
                      top-right
                      text="Click Reset Filters to clear all filters."
                    >
                      <jha-button
                        data-auto-id="resetFiltersBtn"
                        type="button"
                        primary
                        large
                        sync
                        ?disabled=${this.loading}
                        @click=${this.onFiltersClickReset}
                        ><jha-icon-refresh slot="icon-left"></jha-icon-refresh
                        >Reset Filters</jha-button
                      >
                    </jha-tooltip>
                  </div>
              </div>
          </div>          
        </div>
      </slot>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "audit-export": AuditExport;
  }
}